var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ArticleComponent',{attrs:{"viewer":true,"model":_vm.model,"draggable":_vm.draggable,"inEdit":false},nativeOn:{"dragstart":function($event){return _vm.ondragstart($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }